import axios from "axios";

export default {
  state: {
    background: {},
  },
  getters: {
    getBackground(state) {
      return state.background;
    },
  },
  mutations: {
    getBackground(state, payload) {
      state.background = payload;
    },
  },
  actions: {
    getBackground(store, { etag }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/activebg",
          headers: {
            "Content-Type": "application/json",
            "If-None-Match": etag,
          },
          validateStatus(status) {
            return (status >= 200 && status < 300) || status === 304;
          },
        })
          .then((res) => {
            if (res.status === 200) {
              res.data.etag = res.headers.etag;
              store.commit("getBackground", res.data);
              resolve(true);
            } else if (res.status === 304) {
              store.commit("getBackground", "not modified");
              resolve(true);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
  },
};
